import React, { useState } from "react";
import Picture from '../../svg/laptop.svg'
import './body.css'
import Text from './text-part/text'

function body() {
    return (
        <div>
            <div className="landing-page pt-8">
                <div className="landing-text">
                    <Text />
                </div>
                <div className="landing-image">
                    <img src={Picture} alt="laptop-image" className="picture" />
                </div>
            </div>
            <div className="pt-8 img-container animate-bounce">
                <a href="#project">
                    <i class="fi-rr-arrow-down"></i>
                </a>
            </div>
        </div>
    )
}

export default body
